(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initReviewCarousel(root){
    if(!root||root.dataset.ddReviewBound==="true")return;
    var viewport=root.querySelector("[data-dd-review-viewport]");
    var track=root.querySelector("[data-dd-review-track]");
    var originals=track?Array.from(track.querySelectorAll("[data-dd-review-slide]")):[];
    var dots=Array.from(root.querySelectorAll("[data-dd-review-dot]"));
    var previous=root.querySelector("[data-dd-review-prev]");
    var next=root.querySelector("[data-dd-review-next]");
    var controls=root.querySelector("[data-dd-review-controls]");
    if(!viewport||!track||!originals.length)return;

    root.dataset.ddReviewBound="true";
    var carousel=root.querySelector(".dd-review-carousel");
    var reduceMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
    var autoplay=root.dataset.autoplay==="true";
    var delay=Math.max(3000,parseInt(root.dataset.autoplayDelay,10)||5000);
    var duration=Math.max(0,parseInt(root.dataset.transitionDuration,10)||600);
    var perView=1;
    var index=0;
    var slides=[];
    var timer=null;
    var dragging=false;
    var startX=0;
    var dragDelta=0;
    var startOffset=0;
    var resizeTimer=null;

    function activeIndex(){
      return((index-perView)%originals.length+originals.length)%originals.length;
    }

    function updateDots(){
      var active=activeIndex();
      dots.forEach(function(dot,dotIndex){
        var selected=dotIndex===active;
        dot.classList.toggle("is-active",selected);
        dot.setAttribute("aria-selected",selected?"true":"false");
      });
    }

    function move(animated){
      var slide=slides[index];
      if(!slide)return;
      track.style.transitionDuration=animated&&!reduceMotion.matches?duration+"ms":"0ms";
      track.style.transform="translate3d("+(-slide.offsetLeft)+"px,0,0)";
      updateDots();
    }

    function stop(){
      window.clearTimeout(timer);
      timer=null;
    }

    function start(){
      stop();
      if(!autoplay||reduceMotion.matches||originals.length<=perView||document.hidden)return;
      timer=window.setTimeout(function(){
        index+=1;
        move(true);
        start();
      },delay);
    }

    function nextSlide(){
      stop();
      index+=1;
      move(true);
      start();
    }

    function previousSlide(){
      stop();
      index-=1;
      move(true);
      start();
    }

    function removeClones(){
      track.querySelectorAll("[data-dd-review-clone]").forEach(function(clone){clone.remove();});
    }

    function cloneSlide(slide){
      var clone=slide.cloneNode(true);
      clone.setAttribute("data-dd-review-clone","");
      clone.setAttribute("aria-hidden","true");
      clone.removeAttribute("data-dd-review-slide");
      clone.removeAttribute("data-shopify-editor-block");
      return clone;
    }

    function rebuild(){
      stop();
      removeClones();
      perView=window.matchMedia("(min-width: 700px)").matches?2:1;
      perView=Math.min(perView,originals.length);

      if(originals.length>perView){
        var before=document.createDocumentFragment();
        var after=document.createDocumentFragment();
        for(var i=originals.length-perView;i<originals.length;i+=1)before.appendChild(cloneSlide(originals[i]));
        for(var j=0;j<perView;j+=1)after.appendChild(cloneSlide(originals[j]));
        track.insertBefore(before,track.firstChild);
        track.appendChild(after);
      }

      slides=Array.from(track.children);
      index=originals.length>perView?perView:0;
      if(controls)controls.hidden=originals.length<=perView;
      window.requestAnimationFrame(function(){
        move(false);
        start();
      });
    }

    track.addEventListener("transitionend",function(event){
      if(event.propertyName!=="transform"||originals.length<=perView)return;
      if(index>=originals.length+perView){
        index=perView;
        move(false);
      }else if(index<perView){
        index=originals.length+index;
        move(false);
      }
    });

    if(previous)previous.addEventListener("click",previousSlide);
    if(next)next.addEventListener("click",nextSlide);

    dots.forEach(function(dot){
      dot.addEventListener("click",function(){
        stop();
        index=perView+parseInt(dot.dataset.ddReviewDot,10);
        move(true);
        start();
      });
    });

    viewport.addEventListener("keydown",function(event){
      if(event.key==="ArrowLeft"){
        event.preventDefault();
        previousSlide();
      }else if(event.key==="ArrowRight"){
        event.preventDefault();
        nextSlide();
      }
    });

    viewport.addEventListener("pointerdown",function(event){
      if(originals.length<=perView)return;
      dragging=true;
      startX=event.clientX;
      dragDelta=0;
      startOffset=slides[index].offsetLeft;
      stop();
      carousel.classList.add("is-dragging");
      track.style.transitionDuration="0ms";
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener("pointermove",function(event){
      if(!dragging)return;
      dragDelta=event.clientX-startX;
      track.style.transform="translate3d("+(-startOffset+dragDelta)+"px,0,0)";
    });

    function finishDrag(event){
      if(!dragging)return;
      dragging=false;
      carousel.classList.remove("is-dragging");
      if(event&&viewport.hasPointerCapture(event.pointerId))viewport.releasePointerCapture(event.pointerId);
      if(dragDelta<-45)index+=1;
      else if(dragDelta>45)index-=1;
      move(true);
      start();
    }

    viewport.addEventListener("pointerup",finishDrag);
    viewport.addEventListener("pointercancel",finishDrag);
    root.addEventListener("mouseenter",stop);
    root.addEventListener("mouseleave",start);
    root.addEventListener("focusin",stop);
    root.addEventListener("focusout",start);
    document.addEventListener("visibilitychange",function(){if(document.hidden)stop();else start();});
    reduceMotion.addEventListener("change",function(){move(false);start();});

    window.addEventListener("resize",function(){
      window.clearTimeout(resizeTimer);
      resizeTimer=window.setTimeout(rebuild,150);
    });

    root.ddReviewGoTo=function(target){
      index=perView+Math.max(0,Math.min(originals.length-1,target));
      move(true);
      start();
    };

    rebuild();
  }

  function initAllReviews(scope){
    (scope||document).querySelectorAll("[data-dd-review-carousel]").forEach(initReviewCarousel);
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){initAllReviews(document);});
  else initAllReviews(document);

  document.addEventListener("shopify:section:load",function(event){initAllReviews(event.target);});
  document.addEventListener("shopify:block:select",function(event){
    var slide=event.target.closest("[data-dd-review-slide]");
    var root=event.target.closest("[data-dd-review-carousel]");
    if(slide&&root&&root.ddReviewGoTo)root.ddReviewGoTo(parseInt(slide.dataset.reviewIndex,10)||0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
